import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getClientChildIssueList, getServiceTypes, addClientChildIssue, updateClientChildIssue, deleteClientChildIssue } from "../slice/clientPanelChildIssueSlice";

const ClientChildIssue = () => {

    const dispatch = useDispatch();
    const { clientsChildIssue, loading, serviceTypes } = useSelector((state) => state.clientChildIssue);
    const [form, setForm] = useState({
        issue_type: "",
        issue_name: "",
        issue_description: "",
    });
    const [selectedIssue, setSelectedIssue] = useState(null);
    const [sortConfig, setSortConfig] = useState({ column: null, direction: "asc" });

  const clientToken = localStorage.getItem("client_access_token");

  const handleFormChange = (e) => {
    const { name, value, files } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  const sortedData = [...(Array.isArray(clientsChildIssue) ? clientsChildIssue : [])].sort((a, b) => {
  if (sortConfig.column === null) return 0;

  const key = sortConfig.column;
  const valA = a[key] ?? "";
  const valB = b[key] ?? "";

  if (!isNaN(valA) && !isNaN(valB)) {
    return sortConfig.direction === "asc"
      ? valA - valB
      : valB - valA;
  } else {
    return sortConfig.direction === "asc"
      ? valA.toString().localeCompare(valB.toString())
      : valB.toString().localeCompare(valA.toString());
  }
});

   const handleSort = (columnKey) => {
      let direction = "asc";
      if (sortConfig.column === columnKey && sortConfig.direction === "asc") {
         direction = "desc";
      }
      setSortConfig({ column: columnKey, direction });
   };


   useEffect(() => {
      dispatch(getClientChildIssueList(clientToken));
      dispatch(getServiceTypes());
    }, [dispatch]);

    // console.log("clientsChildIssue", clientsChildIssue);

    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    
    const handleAddChildIssueModel = () => {
        setForm({ document_type: "", issue_name: "", issue_description: "" });
        setShowAddModal(true);
    };
    
    const handleCloseAddChildIssueModal = () => {
        setShowAddModal(false);
    };
    
    const handleEditChildIssueModel = (issue) => {
        setSelectedIssue(issue);
        setForm({ 
            issue_type: issue.issue.id?.toString() || "", 
            issue_name: issue.issue_name || "", 
            issue_description: issue.issue_description || ""
        });
        setShowEditModal(true);
    };
    
    const handleCloseEditChildIssueModal = () => {
        setShowEditModal(false);
    };

    const handleAddSubmit = async () => {

        const formData = new FormData();
        formData.append("issue_type", form.issue_type);
        formData.append("issue_name", form.issue_name);
        formData.append("issue_description", form.issue_description);

        const result = await dispatch(
    addClientChildIssue({
      token: clientToken,
      formData: formData,
    })
  );

  if (result.meta.requestStatus === "fulfilled") {
    toast.success("Child issue added successfully", {
      position: "top-right",
      autoClose: 2000,
    });
    handleCloseAddChildIssueModal();
    dispatch(getClientChildIssueList(clientToken)); // Refresh list
  } else {
    toast.error("Failed to add child issue", {
      position: "top-right",
      autoClose: 2000,
    });
  }

    }

        const handleUpdateSubmit = async () => {

        const formData = new FormData();
        formData.append("issue_type", form.issue_type);
        formData.append("issue_name", form.issue_name);
        formData.append("issue_description", form.issue_description);

        const result = await dispatch(
    updateClientChildIssue({
      token: clientToken,
      formData: formData,
      issueId: selectedIssue.id,
    })
  );

  if (result.meta.requestStatus === "fulfilled") {
    toast.success("Child issue updated successfully", {
      position: "top-right",
      autoClose: 2000,
    });
    handleCloseEditChildIssueModal();
    dispatch(getClientChildIssueList(clientToken)); // Refresh list
  } else {
    toast.error("Failed to update child issue", {
      position: "top-right",
      autoClose: 2000,
    });
  }

    }

    const handleDeleteIssue = async (IssueId) => {
        const confirmed = window.confirm("Are you sure you want to delete this issue?");
        if (!confirmed) return;
    
        const result = await dispatch(deleteClientChildIssue({ token: clientToken, IssueId }));
    
        if (result.meta.requestStatus === "fulfilled") {
          toast.success("Issue deleted successfully", {
            position: "top-right",
            autoClose: 2000,
            style: { fontSize: "0.85rem" },
          });
          dispatch(getClientChildIssueList(clientToken)); // Refresh list
        } else {
          toast.error("Failed to delete issue", {
            position: "top-right",
            autoClose: 2000,
            style: { fontSize: "0.85rem" },
          });
        }
      };

  return (
    <>
      {/* <div className="container mt-4">
            <div className="d-flex justify-content-between align-items-center">
                <h2 className="mb-3">List of Child Issue</h2>
                <button className="btn btn-sm btn-primary" onClick={handleAddChildIssueModel}>Add Child Issue</button>
            </div>
        
            <table className="table table-bordered">
                <thead className="table-light">
                    <tr>
                    <th>Issue Type</th>
                    <th>Issue Name</th>
                    <th>Issue Description</th>
                    <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {Array.isArray(clientsChildIssue) && clientsChildIssue.length > 0 ? (
                        clientsChildIssue.map((issue) => (
                            <tr key={issue.id}>
                                <td>{issue.issue.issue_type}</td>
                                <td>{issue.issue_name}</td>
                                <td>{issue.issue_description}</td>
                                <td>
                                    <button
                                        className="btn btn-sm btn-primary me-2"
                                        onClick={() => handleEditChildIssueModel(issue)}
                                    >
                                        Edit
                                    </button>
                                    <button
                                        className="btn btn-sm btn-danger"
                                        onClick={() => handleDeleteIssue(issue.id)}
                                    >
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))
                    ) : (
                            <tr>
                                <td colSpan="2">No data found.</td>
                            </tr>
                    )}
                </tbody>
            </table>
            {showAddModal && (
                <div className="modal fade show" style={{ display: "block" }} tabIndex="-1" aria-modal="true" role="dialog">
                    <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                        <h5 className="modal-title">Add Child Issue</h5>
                        <button type="button" className="btn-close" onClick={handleCloseAddChildIssueModal} aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                        <form>
                            <div className="mb-3">
                                <label htmlFor="issue_type" className="form-label">
                                    Child Issue Type:
                                </label>
                                <select
                                    className="form-control"
                                    id="issue_type"
                                    name="issue_type"
                                    value={form.issue_type}
                                    onChange={handleFormChange}
                                >
                                    <option value="">Select Service Type</option>
                                    {serviceTypes.map((type) => (
                                        <option key={type.id} value={type.id}>
                                        {type.issue_type}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="issue_name" className="form-label">
                                    File:
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="issue_name"
                                    name="issue_name"
                                    value={form.issue_name}
                                    onChange={handleFormChange}
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="issue_description" className="form-label">
                                    Issue Description:
                                </label>
                                <textarea
                                    type="text"
                                    className="form-control"
                                    id="issue_description"
                                    name="issue_description"
                                    value={form.issue_description}
                                    onChange={handleFormChange}
                                />
                            </div>
                        </form>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={handleCloseAddChildIssueModal}>Close</button>
                            <button className="btn btn-primary" onClick={handleAddSubmit}>Add</button>
                        </div>
                    </div>
                </div>
            </div>
            )}
            {showEditModal && (
                <div className="modal fade show" style={{ display: "block" }} tabIndex="-1" aria-modal="true" role="dialog">
                    <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                        <h5 className="modal-title">Edit Child Issue</h5>
                        <button type="button" className="btn-close" onClick={handleCloseEditChildIssueModal} aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                        <form>
                            <div className="mb-3">
                                <label htmlFor="issue_type" className="form-label">
                                    Child Issue Type:
                                </label>
                                <select
                                    className="form-control"
                                    id="issue_type"
                                    name="issue_type"
                                    value={form.issue_type}
                                    onChange={handleFormChange}
                                >
                                    <option value="">Select Service Type</option>
                                    {serviceTypes.map((type) => (
                                        <option key={type.id} value={type.id}>
                                        {type.issue_type}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="issue_name" className="form-label">
                                    File:
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="issue_name"
                                    name="issue_name"
                                    value={form.issue_name}
                                    onChange={handleFormChange}
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="issue_description" className="form-label">
                                    Issue Description:
                                </label>
                                <textarea
                                    type="text"
                                    className="form-control"
                                    id="issue_description"
                                    name="issue_description"
                                    value={form.issue_description}
                                    onChange={handleFormChange}
                                />
                            </div>
                        </form>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={handleCloseEditChildIssueModal}>Close</button>
                            <button className="btn btn-primary" onClick={handleUpdateSubmit}>Update</button>
                        </div>
                    </div>
                </div>
            </div>
            )}
        </div> */}
<div className="col-md-8 col-xl-9 mt-4 mt-md-0">
    <div className="ps-2 ps-lg-4">
        <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-1 line-hight-2 border-bottom pb-3 montserrat d-flex">
          Child Issues
          <button className="btn btn-danger ms-auto py-2" onClick={handleAddChildIssueModel}>
            <i className="fa fa-user-plus me-1"></i> Add Child Issue
          </button>
          </h4>
          <div className="table-responsive">
            <table className="table table-striped table-bordered align-middle" id="servicesTable">
              <thead>
                <tr>
                  <th className="font-weight-semibold" onClick={() => handleSort("issue_type")}>Issue Type <span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                  <th className="font-weight-semibold" onClick={() => handleSort("issue_name")}>Issue Name <span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                  <th className="font-weight-semibold" onClick={() => handleSort("issue_descitption")}>Issue Description <span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                  <th className="font-weight-semibold">Actions</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(sortedData) && sortedData.length > 0 ? (
                    sortedData.map((issue) => (
                    <tr key={issue.id}>
                        <td>{issue.issue ? issue.issue.issue_type : "N/A"}</td>
                        <td>{issue.issue_name}</td>
                        <td>{issue.issue_description}</td>
                        <td>
                        <button
                            className="btn text-primary p-1"
                            onClick={() => handleEditChildIssueModel(issue)}
                        >
                            <i className="fa fa-pencil font-size-20"></i>
                        </button>
                        <button
                            className="btn btn-md text-danger me-1 p-1"
                            onClick={() => handleDeleteIssue(issue.id)}
                        >
                            <i className="fa fa-trash font-size-20"></i>
                        </button>
                        </td>
                    </tr>
                    ))
                ) : (
                    <tr>
                    <td colSpan="4">No data found.</td>
                    </tr>
                )}
                </tbody>
          </table>
          </div>
    </div>
    {showAddModal && (
                <div className="modal fade show" style={{ display: "block" }} tabIndex="-1" aria-modal="true" role="dialog">
                    <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                        <h5 className="font-weight-bold text-primary font-size-24 line-hight-2 montserrat d-flex">Add Child Issue</h5>
                        <button type="button" className="btn-close" onClick={handleCloseAddChildIssueModal} aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                        <form>
                            <div className="mb-3">
                                <label htmlFor="issue_type" className="form-label text-primary mb-1 font-weight-semibold required">
                                    Child Issue Type:
                                </label>
                                <select
                                    className="form-select"
                                    id="issue_type"
                                    name="issue_type"
                                    value={form.issue_type}
                                    onChange={handleFormChange}
                                >
                                    <option value="">Select Service Type</option>
                                    {serviceTypes.map((type) => (
                                        <option key={type.id} value={type.id}>
                                        {type.issue_type}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="issue_name" className="form-label text-primary mb-1 font-weight-semibold required">
                                    Issue Name:
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="issue_name"
                                    name="issue_name"
                                    value={form.issue_name}
                                    onChange={handleFormChange}
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="issue_description" className="form-label text-primary mb-1 font-weight-semibold">
                                    Issue Description:
                                </label>
                                <textarea
                                    type="text"
                                    className="form-control"
                                    id="issue_description"
                                    name="issue_description"
                                    value={form.issue_description}
                                    onChange={handleFormChange}
                                />
                            </div>
                        </form>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary font-weight-medium font-size-16 text-capitalize px-4 rounded m-1" onClick={handleCloseAddChildIssueModal}>Close</button>
                            <button className="btn btn-custom-primary font-weight-medium font-size-16 text-capitalize px-4 rounded m-1" onClick={handleAddSubmit}>Add</button>
                        </div>
                    </div>
                </div>
            </div>
            )}
            {showEditModal && (
                <div className="modal fade show" style={{ display: "block" }} tabIndex="-1" aria-modal="true" role="dialog">
                    <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                        <h5 className="modal-title">Edit Child Issue</h5>
                        <button type="button" className="btn-close" onClick={handleCloseEditChildIssueModal} aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                        <form>
                            <div className="mb-3">
                                <label htmlFor="issue_type" className="form-label text-primary mb-1 font-weight-semibold required">
                                    Child Issue Type:
                                </label>
                                <select
                                    className="form-select"
                                    id="issue_type"
                                    name="issue_type"
                                    value={form.issue_type}
                                    onChange={handleFormChange}
                                >
                                    <option value="">Select Service Type</option>
                                    {serviceTypes.map((type) => (
                                        <option key={type.id} value={type.id}>
                                        {type.issue_type}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="issue_name" className="form-label text-primary mb-1 font-weight-semibold required">
                                    Issue Name:
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="issue_name"
                                    name="issue_name"
                                    value={form.issue_name}
                                    onChange={handleFormChange}
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="issue_description" className="form-label text-primary mb-1 font-weight-semibold">
                                    Issue Description:
                                </label>
                                <textarea
                                    type="text"
                                    className="form-control"
                                    id="issue_description"
                                    name="issue_description"
                                    value={form.issue_description}
                                    onChange={handleFormChange}
                                />
                            </div>
                        </form>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary font-weight-medium font-size-16 text-capitalize px-4 rounded m-1" onClick={handleCloseEditChildIssueModal}>Close</button>
                            <button className="btn btn-custom-primary font-weight-medium font-size-16 text-capitalize px-4 rounded m-1" onClick={handleUpdateSubmit}>Update</button>
                        </div>
                    </div>
                </div>
            </div>
            )}
</div>


    </>
  );
};

export default ClientChildIssue;